export const en = {
    COMMON: {
        APP_NAME: 'Musa EHR',
        YES: 'Yes',
        NO: 'No',
        SHARED: {
            PRIMARY: 'Primary',
        },
        SESSION: {
            WARNING:
                'Your session’s about to take a nap! Better wrap things up soon or you’ll be logged out. Don’t worry, we’ll be here when you get back!',
        },
        ADMIN: {
            USERS: {
                ERROR_TITLE: 'Error saving user',
                ERRORS: {
                    CANT_DEACTIVATE_SELF: 'You cannot deactivate your own account',
                    USER_ALREADY_ADMIN: 'The user you are trying to add is already an admin',
                },
            },
        },
        LOGIN: {
            CHECKING_CREDENTIALS: 'Checking credentials',
            EMAIL: 'Email Address',
            PASSWORD: 'Password',
            LOGIN: 'login',
            RESET_PASSWORD: 'Reset Password',
            RETURN_TO_LOGIN: 'Return to Login',
            RESET_TITLE: 'Reset Password',
            SET_TITLE: 'Register with MUSA',
            SET_CONFIRM: 'Register',
            CHECK_EMAIL: 'Please check your email to continue.',
            RESET_CONFIRMED: 'Check Your Email',
            RESET_INSTRUCTIONS: `We've sent password reset instructions to your email address. Please check your inbox and follow the link provided.`,
            NEW_PASSWORD: 'New Password',
            CONFIRM_NEW_PASSWORD: 'Confirm New Password',
            RESETTING_PASSWORD: 'Processing...',
            CODE: 'Verification Code',
            ERRORS: {
                EXPIRED: 'Oops! Looks like your session took a little break. Please log in again to get back to saving lives!',
                EMAIL_REQUIRED: 'Email is required',
                PASSWORD_REQUIRED: 'Password is required',
                NO_ACTIVE_SUBSCRIPTIONS: 'Your account has no active subscriptions. Please contact your administrator for assistance.',
                PASSWORD_COMPLEXITY:
                    'Password must be at least 8 characters and contain at least 1 uppercase letter, least 1 number and least 1 symbol',
                PASSWORD_MATCH: 'Passwords must match',
                NOT_VERIFED: 'The account has not been verified, please reset password to continue',
                INCORRECT_USERNAME_OR_PASSWORD: 'Incorrect username or password',
                ACCOUNT_LOCKED: 'The account has been locked for 15 minutes, please try again later',
                REUSE_RECENT_PASSWORD: 'Reset failed, cannot reuse a recent password.',
                ORGANIZATION_DEACTIVATED: 'Your organization has been deactivated. Please contact your administrator for more information.',
                ORGANIZATION_SWITCH_DEACTIVATED: 'This organization is currently deactivated and cannot be accessed.',
                ORGANIZATION_SWITCH_ERROR: 'Failed to switch organization. Please try again.',
                Unauthorized: 'Reset failed, please request another reset code.',
                'password must be at least 8 characters': 'password must be at least 8 characters',
                'password must contain at least 1 uppercase letter': 'password must contain at least 1 uppercase letter',
                'password must contain at least 1 number': 'password must contain at least 1 number',
                'password must contain at least 1 symbol': 'password must contain at least 1 symbol',
            },
        },
        PATIENT: {
            STATUS: {
                REFERRAL: 'Referral',
                INTAKE: 'Intake',
                PENDING: 'Pending',
                PENDING_ELIGIBILITY: 'Pending Eligibility',
                NON_ADMIT: 'Non Admit',
                ADMITTED: 'Admitted',
                TRANSFERRED: 'Transferred',
                DISCHARGED: 'Discharged',
                DECEASED: 'Deceased',
            },
            LIVES_WITH: {
                alone: 'Lives Alone',
                spouse: 'Lives with Spouse',
                family: 'Lives with Family',
                friend: 'Lives with Friend',
                paid: 'Lives with Paid Help (not Family)',
                other: 'Other',
            },
        },
        PHYSICIAN: {
            ROLES: {
                referring: 'Referring',
                PCP: 'PCP',
                F2F: 'F2F',
            },
            OVERSEE_POC: 'Oversee POC and Sign Orders',
        },
        MEDICATIONS: {
            SIGN_OFF: {
                ATTESTATION:
                    "By signing I am attesting that this list accurately describes the patient's current medication regimen to the best of my knowledge.",
                ORDER_REMINDER: 'Otherwise, please create an order to document any changes.',
            },
        },
        REFERRAL: {
            TYPES: {
                RN: 'RN',
                SN: 'SN',
                PT: 'PT',
                OT: 'OT',
                ST: 'ST',
                MSW: 'MSW',
                OTHER: 'OTHER',
            },
        },
        PROFILE: {
            CAREGIVER: {
                RELATIONSHIP: {
                    spouse: 'Spouse',
                    child: 'Child',
                    sibling: 'Sibling',
                },
                POINT_OF_CONTACT: 'Point of Contact',
                EMERGENCY_CONTACT: 'Emergency Contact',
                LEGAL_REPRESENTATIVE: 'Legal Representative',
                ABILITY: {
                    TITLE: 'Ability',
                    able: 'Able',
                    limited: 'Limited',
                    unable: 'Unable',
                },
            },
            PROVIDERS: {
                PHYSICIAN: {
                    TITLE: 'Physicians',
                },
                PHARMACY: {
                    TITLE: 'Pharmacies',
                },
                REFERRAL: {
                    TITLE: 'Referral',
                    LABELS: {
                        RECEIVED_BY: 'Received By',
                        REFERRAL_SOURCE: 'Referral Source',
                        ADMIT_SOURCE: 'Admit Source',
                        REFERRAL_DATE: 'Referral Date',
                        START_OF_CARE_DATE: 'Start of Care Date',
                        NOTES: 'Notes',
                        REQUIRED_CARE_TYPES: 'Required Care Types',
                        SPECIFIC_INSTRUCTIONS: 'Specific Instructions',
                    },
                },
            },
        },
        INSURANCE: {
            TYPE: {
                medicare: 'Medicare',
                medicaid: 'Medicaid',
                private: 'Private',
                'self-pay': 'Self Pay',
                'no-pay': 'No Pay',
                none: 'None',
            },
        },
        INTAKE: {
            TITLE: 'Patient Intake',
            patient: {
                TITLE: 'Patient Details',
            },
            insurance: {
                TITLE: 'Insurance',
            },
            demographics: {
                TITLE: 'Demographics',
            },
            contacts: {
                TITLE: 'Contacts',
            },
            support: {
                TITLE: 'Support',
            },
            referral: {
                TITLE: 'Referrals',
            },
            providers: {
                TITLE: 'Providers',
            },
            diagnoses: {
                TITLE: 'Diagnoses',
            },
            risksAllergies: {
                TITLE: 'Risk & Allergies',
            },
            ERRORS: {
                EXISTING_PATIENT: 'Unable to admit patient with active existing admission',
            },
        },
        ABN: {
            LANGUAGE: {
                SECTION_TITLE: 'Language',
            },
            WARNING_BEFORE: "Medicare doesn't pay for everything, even some care you or your health care provider think you need.",
            WARNING_BOLD: 'We expect Medicare may not pay for the item, test, service or care listed below.',
            WARNING_AFTER: "If Medicare doesn't pay, you may have to pay.",
            FIELD1: 'Item, test, service or care',
            FIELD2: 'Reason Medicare may not pay',
            FIELD3: 'Estimated Cost',
            ADD_ITEM: 'Add Item',
            NEED_TO_KNOW: {
                TITLE: 'What to do now',
                ITEM1: 'Read this notice to make an informed decision about your care.',
                ITEM2: 'Ask any questions you have.',
                ITEM3: 'Choose one option below to let us know if you still want to get the item, test, service or care.',
            },
            OPTIONS: {
                SECTION_TITLE: 'Options',
                HEADER: "Choose ONE option below. We can't choose for you.",
                SUBHEADER:
                    "If you choose Option 1 or 2, we may help you use any other insurance you might have, but Medicare can't require us to do this.",
                OPTION1: {
                    LABEL: 'Option 1',
                    DESCRIPTION_BOLD:
                        "I want the item, test, service or care listed above, and I want Medicare to be billed for an official decision on payment, which I'll get on a Medicare Summary Notice (MSN).",
                    DESCRIPTION_NORMAL:
                        "You can ask to be paid now. I understand that if Medicare doesn't pay, I'm responsible to pay, but I can appeal to Medicare by following the directions on the MSN. If Medicare does pay, you'll refund any payments I made to you, minus co-pays or deductibles.",
                },
                OPTION2: {
                    LABEL: 'Option 2',
                    DESCRIPTION_BOLD: "I want the item, test, service or care listed above, but don't bill Medicare.",
                    DESCRIPTION_NORMAL:
                        "You can ask to be paid now and I'm responsible to pay. I understand I can't appeal, since Medicare isn't billed.",
                },
                OPTION3: {
                    LABEL: 'Option 3',
                    DESCRIPTION_BOLD: "I don't want the item, test, service or care listed above.",
                    DESCRIPTION_NORMAL: "I understand I'm not responsible for payment and I can't appeal to see if Medicare would pay.",
                },
            },
            ADDITIONAL_INFORMATION: {
                SECTION_TITLE: 'Additional Information',
                NOTES_PLACEHOLDER: 'Fill in additional information if any',
                ITEM1: 'This notice gives our opinion, not an official Medicare decision.',
                ITEM2: 'If you have other questions on this notice or Medicare billing, call 1-800-MEDICARE (1-800-633-4227 / TTY: 1-877-486-2048).',
                ITEM3: 'Signing below means that you have received and understand this notice. You may ask to receive a copy.',
                ITEM4: "You have the right to get Medicare information in an accessible format, like large print, Braille, or audio. You also have the right to file a complaint if you feel you've been discriminated against. Visit Medicare.gov/about-us/accessibility-nondiscrimination-notice.",
            },
            EFFECTIVE_DATE: {
                SECTION_TITLE: 'Effective Date',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Signature of Patient or Authorized Representative',
                AGREE: 'Patient or authorized representative agrees to sign this document electronically with an e-signature by checking this box.',
                AUTHORIZED_REP:
                    'Check here if you are signing as an Authorized Representative and make sure your name is legible or print your name, if not legible.',
                AUTHORIZED_REP_NAME_LABEL: 'Authorized Representative Name',
                AUTHORIZED_REP_NAME_PLACEHOLDER: 'First and last name',
                AUTHORIZED_REP_FALLBACK: 'Authorized Representative',
                REFUSED_TO_SIGN: 'Patient refused to sign',
            },
            COMPLETE: 'Complete',
        },
        NOMNC: {
            LANGUAGE: {
                SECTION_TITLE: 'Language',
            },
            SERVICE_TYPE: {
                SECTION_TITLE: 'Service Type',
                LABEL: 'Select the type of service being terminated',
                PLACEHOLDER: 'e.g., skilled nursing, home health, comprehensive outpatient rehabilitation service, or hospice',
                OTHER_LABEL: 'Please specify',
                OTHER_PLACEHOLDER: 'Describe other service type',
            },
            WARNING:
                "Your provider and/or health plan determined that Medicare probably won't pay for your below services after the below date. You may have to pay for any services you get after this date.",
            EFFECTIVE_DATE: {
                SECTION_TITLE: 'Effective Date',
                LABEL: 'Coverage end date',
            },
            QIO: {
                SECTION_TITLE: 'Quality Improvement Organization (QIO)',
                LABEL: 'QIO name and toll-free number',
                NAME_LABEL: 'QIO name',
                PHONE_LABEL: 'QIO toll-free number',
            },
            APPEAL: {
                SECTION_TITLE: 'Your Right to Appeal This Decision',
                ITEM1: "You have the right to appeal the decision to end Medicare coverage of your services. This means you'll get an independent medical review right away. Your services will continue during the appeal.",
                ITEM2: "If you choose to appeal, the independent reviewer will ask for your opinion. You don't have to prepare anything in writing, but you have the right to do so. The reviewer also will look at your medical records and/or other relevant information.",
                ITEM3: "Once you ask for an appeal, you'll get a notice with a detailed explanation about why your service coverage should end.",
                ITEM4: 'If the independent reviewer agrees Medicare coverage for your services should end, neither Medicare nor your plan will pay for these services after the above date.',
                ITEM5: "If you stop services by the above date, you'll avoid financial liability.",
            },
            HOW_TO_APPEAL: {
                SECTION_TITLE: 'How to Ask for an Immediate Appeal',
                ITEM1: 'Ask for the appeal as soon as possible. You must ask for a timely appeal no later than noon of the day before the above date.',
                ITEM2: 'Make your request to your Quality Improvement Organization (QIO). A QIO is the independent reviewer authorized by Medicare.',
                ITEM3: 'If you miss the deadline to ask for an immediate appeal, you may still have appeal rights.',
                ITEM4: 'Call your QIO {{qioName}}, at {{qioPhone}} to appeal, or if you have questions.',
            },
            WHAT_HAPPENS: {
                SECTION_TITLE: 'What Happens Next',
                ITEM1: "The QIO will let you know its decision as soon as possible, generally no later than two days after the effective date above. If you're in a Medicare health plan, the QIO generally will let you know its decision by the effective date above.",
                ITEM2: 'Call your QIO, {{qioName}}, at {{qioPhone}} to learn more.',
            },
            ADDITIONAL_INFORMATION: {
                SECTION_TITLE: 'Additional Information (Optional)',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Signature of Patient or Representative',
                AGREE: "I've been notified that coverage of my services will end on the date on this notice, and that I can appeal this decision by contacting my QIO.",
                DATE_LABEL: 'Date',
                REFUSED_TO_SIGN: 'Patient refused to sign',
            },
        },
        HHCCN: {
            LANGUAGE: {
                SECTION_TITLE: 'Language',
            },
            CHANGES: {
                SECTION_TITLE: 'Home Health Change of Care Notice (HHCCN)',
                FIELD1: 'What items/services are changing?',
                FIELD2: 'Reason for change',
                ADD_ITEM: 'Add Item',
            },
            STARTING_DATE: {
                SECTION_TITLE: 'Starting Date',
                LABEL: 'Date changes begin',
            },
            NOTICE_REASON: {
                SECTION_TITLE: 'Why are you getting this notice?',
                OPTION1: {
                    LABEL: "Your doctor/provider changed (or didn't renew) the order for your home care.",
                    DESCRIPTION:
                        "The home health agency must follow doctor/provider orders to give you care. If you don't agree with this change, discuss it with your home health agency or the doctor/provider who orders your home care.",
                },
                OPTION2: {
                    LABEL: 'Your home health agency decided to stop giving you the items/services for the reasons listed above.',
                    DESCRIPTION:
                        'If you think you still need home care, you can look for care from a different home health agency if you have a valid order. For help finding a different home health agency, contact the doctor/provider who ordered your home care. If you get care from a different home health agency, you can ask it to bill Medicare.',
                },
            },
            GET_HELP: {
                SECTION_TITLE: 'Get help or more information',
                CONTENT:
                    "If you have questions about these changes, contact your home health agency and/or the doctor/provider who orders your home care. You can't appeal to Medicare about payment for the items/services listed above unless you get the items/services and a Medicare claim is filed.",
            },
            OPTIONAL_DETAILS: {
                SECTION_TITLE: 'Optional Details',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Signature',
                HEADING: 'Sign below to show you understand this notice',
                AGREE: 'Patient or authorized representative agrees to sign this document electronically with an e‑signature.',
                PATIENT_AGREE: 'Patient agrees to sign this document electronically with an e‑signature.',
                REPRESENTATIVE_AGREE: 'Authorized representative agrees to sign this document electronically with an e‑signature.',
                AUTHORIZED_REP:
                    "Check here if you're signing as an Authorized Representative and make sure your name is legible or print your name, if not legible.",
                AUTHORIZED_REP_NAME_LABEL: 'Authorized Representative Name',
                AUTHORIZED_REP_NAME_PLACEHOLDER: 'First and last name',
                AUTHORIZED_REP_FALLBACK: 'Authorized Representative',
                REFUSED_TO_SIGN: 'Patient refused to sign',
            },
            ACCESSIBILITY: {
                CONTENT:
                    "You have the right to get your information in an accessible format, like large print, Braille, or audio. You also have the right to file a complaint if you feel you've been discriminated against. Visit Medicare.gov/about-us/accessibility-nondiscrimination-notice, or call 1-800-MEDICARE (1-800-633-4227) for more information. TTY users can call 1-877-486-2048.",
            },
        },
        PATIENT_CONSENT: {
            LANGUAGE: {
                SECTION_TITLE: 'Language',
            },
            I_CONSENT: 'I Consent',
            I_DO_NOT_CONSENT: 'I do not consent',
            REQUEST: {
                SECTION_TITLE: 'Request For Initial Assessment/Admission/Consent for Treatment',
                CONTENT:
                    'I hereby request and agree to initial assessment and, if I am able to be admitted to {{agencyNameComplete}} (hereafter {{agencyName}}), I consent for approved personnel from {{agencyName}} to perform all necessary procedures and treatments ordered by my physicians for my home health care. I realize my care is directed and monitored by my doctor, who is neither an employee nor an agent of {{agencyName}}, and {{agencyName}} is not liable for any act or omission when following the instructions of the doctor.',
            },
            CLIENT_RIGHTS: {
                SECTION_TITLE: 'Client Rights and Responsibilities',
                CONTENT:
                    'I understand my Rights and Responsibilities. I have received a written notice of my Rights and Responsibilities and the OASIS Statement of Patient Privacy Act Statement, and the Notice of Privacy Practices before care was furnished by the staff of {{agencyName}}.',
            },
            ADVANCE_DIRECTIVE_RESUSCITATION: {
                SECTION_TITLE: 'Advance Directives/Resuscitation',
                CONTENT:
                    'I am aware that if I do not have, or fail to produce a properly executed copy of an advance directive, {{agencyName}} will be obligated to perform cardiac resuscitation and call paramedics if my condition indicates a need for such intervention.',
            },
            COMPLAINTS: {
                SECTION_TITLE: 'Registration of Complaints',
                CONTENT:
                    'I agree to notify a {{agencyName}} Registered Nurse if I have a complaint. I understand that if the Registered Nurse does not resolve the complaint, I or a member of my family should register the complaint in writing to the Administrator. I understand that each person to whom my complaint is directed in writing must respond to the complaint within five (5) working days of the receipt of the written complaint.',
            },
            HOTLINE: {
                SECTION_TITLE: 'Hotline',
                CONTENT:
                    'I have been given information and instructions on {{agencyName}} procedures on complaint resolution. As a patient I understand I have the right to file a complaint with the Department of Health and Human Services Nevada Division of Public and Behavioral Health (DPBH) without being subject to discrimination or reprisal. The hotline is 1-800-225-3414, available 24 hours/day. I understand I also have the right to use this hotline to lodge complaints concerning the implementation of advance directive requirements. I may also contact:',
                NAME: 'Hotline Name: {{name}}',
                PHONE: 'Hotline Phone: {{phone}}',
                ADDRESS: 'Hotline Address: {{address}}',
            },
            AUTH_RELEASE: {
                SECTION_TITLE: 'Authorization to Release Information',
                CONTENT:
                    'I consent to the release of any information regarding my medical condition by any recognized health agency, institution or medical group/office in which I have been a patient, and I authorize the release and/or disclosure or any medical records or information by the preceding to {{agencyName}} and those involved in my care while admitted to {{agencyName}}. I understand my medical records may be revealed to federal and state accrediting bodies and by the Quality Management/Utilization Review Committees of {{agencyName}}.',
                NOT_ALLOWED: 'Information may not be released about',
                NOT_RELEASED_TO: 'Information may not be released to',
            },
            PAYMENT_REQUEST: {
                SECTION_TITLE: 'Payment Request/Assignment of Benefits',
                CONTENT:
                    'I certify that all Medicare, HMO, Medicaid, or any other health care payment information given to {{agencyName}} is true and accurate and I authorize {{agencyName}} to request payment on my behalf. I authorize the release of any and all records that may be required to secure payment. I understand I must notify {{agencyName}} immediately of any changes in my medical coverage including Medicare and Medicaid. I also understand that if I change insurance coverage while under the care of {{agencyName}} I will be responsible for any changes not covered as a result of the change in coverage. I hereby authorize {{agencyName}} to use and/or disclose my health information for treatment, payment, or health care operations and coordinations.',
            },
            MEDICARE_PATIENTS: {
                SECTION_TITLE: 'Medicare Patients',
                CONTENT:
                    'I understand that {{agencyName}} accepts all Medicare Part A and Part B as payment in full for all skilled nursing and rehabilitation services and that I will be notified, in advance, if there are any charges for medical equipment and supplies.',
                CONTENT2:
                    'I am aware that I am responsible for any non-covered costs, share of cost, or co-pay in consideration for the services I am to receive. All reasonable attempts will be made by {{agencyName}} to collect these payments. Anticipated charges include:',
                SNCHARGE: '${{charge}} per hour visit for SN',
                PTCHARGE: '${{charge}} per hour visit for PT',
                OTCHARGE: '${{charge}} per hour visit for OT',
                STCHARGE: '${{charge}} per hour visit for ST',
                HHACHARGE: '${{charge}} per hour visit for CHHA',
                MSWCHARGE: '${{charge}} per hour visit for MSW',
            },
            PROPOSE_SERVICES: {
                SECTION_TITLE: 'Proposed Services and Frequency of Visits',
                CONTENT:
                    'I have been actively involved in the planning of my care with {{agencyName}} and I understand that the following services and visits will be provided if needed and approved by my doctor:',
                CONTENT2: 'At least one service is required',
            },
            ADVANCE_DIRECTIVE: {
                SECTION_TITLE: 'Advance Directives',
                ITEM1: 'I have completed an Advance Directive',
                ITEM2: 'I have Durable Power of Attorney for Health Care',
                ITEM3: 'I have a living will',
                ITEM4: 'I have a DO NOT Resuscitate Directive',
                ITEM5: 'Other (explain)',
                ITEM6: 'I do not know if I have any of the above.',
                ITEM7: 'I understand that I must provide a copy of any of these documents in order for my wishes to be followed regarding my health care.',
                ITEM8: 'Copy obtained for chart',
                ITEM9: 'Physician Order for Life-Sustaining Treatment (POLST)',
                ITEM10: 'Medical Order for Life-Sustaining Treatment (MOLST)',
                ITEM11: 'Other Legally Valid Document under state law',
                ITEM12: 'Surrogate Decision Maker',
                ITEM13: "If any of the following information is documented in the patient's advance care plan, please specify below:",
                ITEM14: 'Medical Treatment Preferences',
                ITEM15: 'Mental Health/Behavioral Preferences',
                ITEM16: 'Cultural/Social Preferences',
                ITEM17: 'Spiritual/Religious Preferences',
            },
            PRIVACY_NOTICE: {
                SECTION_TITLE: 'Privacy Notice',
                ITEM1: 'OASIS Privacy Act Statement – Health Care Records confidentiality and retrieval',
                ITEM2: 'I have been instructed and given a written notice of the Privacy Act Statement on OASIS to advise me of my rights, principle purposes, routine uses and what may result from my future to provide accurate information to complete OASIS. I have been given information on the confidentiality and the disclosure of my clinical records maintained by {{agencyName}}. I have been given information on how to retrieve and obtain a copy of my medical records maintained by {{agencyName}}.',
                ITEM3: 'Information on Safety Information/Emergency Preparedness/Infection Control & Universal Precautions/911 Protocol and s/s to Report to MD is given to me at initial evaluation and on an ongoing basis as needed.',
            },
            PHOTO_CONSENT: {
                SECTION_TITLE: 'Consent to Photograph',
                CONTENT:
                    'to the appropriate part(s) of my body being photographed by {{agencyName}} personnel in order to provide supporting documentation to my medical condition (I understand that any photographs taken will be placed in and remain part of my medical record).',
            },
            HIPPA: {
                SECTION_TITLE: 'Health Insurance Portability and Accountability Act (HIPAA)',
                CONTENT:
                    'Permission to Use and Disclose Your Health Information: By signing this consent, I authorize {{agencyName}} to use and/or disclose my health information for treatment, payment or health care operations. I have the right not to sign this consent. However, if I refuse to sign this consent, {{agencyName}} has the right to refuse me service.',
            },
            PATIENT_RIGHTS: {
                SECTION_TITLE: 'Patient Rights',
                CONTENT:
                    'As a patient you have the following rights. {{agencyName}} must protect and promote the exercise of these rights.',
                ITEM0: '{{agencyName}} must provide you with written notice of these rights including the OASIS Statement of Patient Privacy Rights, the Privacy Act Statement and Notice of Privacy Practice prior to furnishing care or during initial evaluation procedures.',

                ITEM1: 'You have the right to be treated with consideration, respect and full recognition of dignity and individuality, to be given appropriate and professional home health services without discrimination against your race, religion, gender, age, creed, marital status, political status, sexual orientation, diagnosis or source of payment, and to be assured that the personnel who provide care are qualified through education and experience to carry out the services for which they are responsible.',

                ITEM2: 'You have the right to receive services appropriate to your needs, and to be informed of the nature and purpose of all skilled and non-skilled services, technical procedures to be performed including information about the potential benefits and burdens as well as when and who will perform the procedures, and expect {{agencyName}} to provide safe, professional care at the required level of intensity.',

                ITEM3: 'You have the right to receive reasonable continuity of care.',

                ITEM4: 'You have the right to have staff communicate in a language or form you can reasonably be expected to understand (When possible, {{agencyName}} assists with or may provide special devices, interpreters, or other aids to facilitate communication).',

                ITEM5: 'Your family or guardian may exercise your rights through a Durable Power of Attorney for Health Care, should you be unable to make them for yourself.',

                ITEM6: 'You have the right to have your property treated with respect.',

                ITEM7: 'You have the right to voice grievances about treatment or care that is (or fails to be) furnished, or regarding lack of respect for your property without reprisal or discrimination for the same, and be informed of the procedure to voice complaints/grievances with {{agencyName}}.',

                ITEM8: '{{agencyName}} must investigate any complaints made by you, your family, or your guardian regarding any grievances you may have and {{agencyName}} must document the existence and outcome of such grievances.',

                ITEM9: 'You have the right to be informed in advance of the care to be furnished.',

                ITEM10: '{{agencyName}} must advise you in advance of the disciplines that will furnish healthcare and of the frequency of proposed visits.',

                ITEM11: '{{agencyName}} must advise you of any change in the plan of care before the change is made.',

                ITEM12: 'You have the right to participate in the planning of your care.',

                ITEM13: 'You have the right to refuse treatment and to be advised of the consequences of such refusal.',

                ITEM14: 'You have the right to refuse any experimental treatment and/or participate in research unless you give documented voluntary consent.',

                ITEM15: '{{agencyName}} must inform you and provide you with written information in advance regarding its policy on Advance Directives and to include a description of Nevada State law.',

                ITEM16: '{{agencyName}} will provide the information during evaluation.',

                ITEM17: 'You have the right to have your medical records, which are maintained by {{agencyName}}, remain confidential.',

                ITEM18: 'You have the right to approve or disapprove in writing the release of your medical records to any individual employed outside of {{agencyName}}.',

                ITEM19: '{{agencyName}} must advise you of its policies and procedures regarding the disclosure of medical records.',

                ITEM20: 'You or your legal representative has the right to obtain a copy of your medical records by giving {{agencyName}} three (3) days’ advance notice.',

                ITEM21: 'You will be charged 40 cents per page.',

                ITEM22: 'You have the right to be advised, before care is initiated, of the extent to which payment for {{agencyName}} services may be expected from Medicare or other sources, and the extent to which payment may be required from you.',

                ITEM23: 'Before initiating care, {{agencyName}} must inform you verbally or in writing of: Charges for services and Durable Medical Equipment (DME) that will not be covered by Medicare Charges for services and Durable Medical Equipment (DME) that you may have to pay You have the right to be advised verbally and in writing of any changes in the information regarding payment within 30 days from the date {{agencyName}} becomes aware of such changes.',

                ITEM24: 'You have the right to review a copy of {{agencyName}}’s Notice of Privacy Practices before signing this consent.',

                ITEM25: '{{agencyName}}’s Notice of Privacy Practice details how {{agencyName}} may use and disclose your health information.',

                ITEM26: '{{agencyName}} may amend the Notice from time to time.',

                ITEM27: 'A copy of our Notice of Privacy Practice is included in your Home Chart.',

                ITEM28: 'You have the right to request that {{agencyName}} restrict the use and/or disclosure of your medical records for the purpose of providing treatment, obtaining payment for our services, and/or conducting healthcare operations.',

                ITEM29: 'Such requests must be made in writing.',

                ITEM30: 'Please note that {{agencyName}} is not required to agree to any restriction you may request.',

                ITEM31: 'If however, {{agencyName}} decides to agree on a restriction you have requested, {{agencyName}} must restrict its use and/or disclosure of your medical records in the manner described in your request.',

                ITEM32: 'To obtain a restriction request form, please contact {{agencyName}}.',

                ITEM33: 'You have the right to revoke this consent at any time.',

                ITEM34: 'Your revocation of this consent must be in writing.',

                ITEM35: 'If you wish to revoke this consent, please contact {{agencyName}} to obtain a revocation form.',

                ITEM36: 'Note that your revocation of this consent will not be effective for disclosures {{agencyName}} has already made based on your prior consent.',

                ITEM37: '{{agencyName}} also reserves the right to refuse to provide further treatment if you revoke this consent.',

                ITEM38: 'This consent is effective unless and until you revoke it in writing.',

                ITEM39: 'SELF-DETERMINATION · YOU HAVE THE RIGHT:',

                ITEM40: 'To refuse the treatment and be told of the expected consequences of said action.',

                ITEM41: 'To have the agency comply with advance directives as permitted by State law and requirements.',

                ITEM42: 'To receive care whether or not you have an advance directive.',

                ITEM43: "To be informed of the organization's policy and procedures for implementing advance directives.",

                ITEM44: 'To receive information concerning the aspects of his/her condition that relate to the care provided by the agency and participate in decisions regarding his/her care.',

                ITEM45: 'To refuse to participate in experimental treatment or research.',

                ITEM46: 'To participate in the consideration of ethical issues that arise in his/her care.',

                ITEM47: 'To make informed decisions regarding his/her care.',
            },
            PATIENT_RESPONSIBLITY: {
                SECTION_TITLE: 'Patient Responsibilities',
                CONTENT: 'As a patient you have the following responsibilities.',
                ITEM0: 'Remain under a doctor’s care while receiving services from {{agencyName}}.',

                ITEM1: 'Provide {{agencyName}} with complete and accurate health and OASIS information.',

                ITEM2: 'Sign the required consent prior to care being administered or received.',

                ITEM3: 'Provide a safe environment for {{agencyName}} staff.',

                ITEM4: 'Treat {{agencyName}} personnel with respect and consideration.',

                ITEM5: 'Notify {{agencyName}} when you cannot keep appointments.',

                ITEM6: 'Comply with a plan of treatment while under the care of {{agencyName}} and understand that non-compliance may result in discharge from {{agencyName}}.',

                ITEM7: 'Participate in and follow your plan of care.',

                ITEM8: 'Provide {{agencyName}} with a copy of Advance Directives if applicable.',

                ITEM9: 'Provide the evaluating staff with OASIS data as mandated by Medicare and consent that {{agencyName}} transmit OASIS data to CMS (HCFA) (A copy of OASIS Statement of Privacy Rights and the Privacy Act Statement will be provided to you prior to start of care).',
            },
            CONTACT: {
                SECTION_TITLE: 'Contact',
                AVAILIBILITY: 'You may contact a representative from:',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Acknowledgement of Notice',
                CONTENT: 'Patient or authorized representative agrees to sign this document electronically with an e‑signature.',
                PATIENT_CONTENT: 'Patient agrees to sign this document electronically with an e‑signature.',
                REPRESENTATIVE_CONTENT: 'Authorized representative agrees to sign this document electronically with an e‑signature.',
                REFUSED_TO_SIGN: 'Patient refused to sign',
            },
            COMPLETE: 'Complete',
        },
        CALANDER: {
            timeGridDay: 'Day',
            dayGridWeek: 'Week',
            dayGridMonth: 'Month',
        },
        SCHEDULE_FILTER: {
            EMPLOYEE: 'Employee',
            PATIENT: 'Patient',
            STATUS: 'Status',
            DISCIPLINE: 'Discipline',
            CLEAR_ALL: 'Clear all',
            FILTER_VISITS: 'Filter visits',
            FILTER_SUBTITLE: 'Refine the visit list',
            DONE: 'Done',
            ACTIVE_COUNT_one: '{{count}} filter active',
            ACTIVE_COUNT_other: '{{count}} filters active',
            SEARCH_PATIENT: 'Search patient',
            NO_PATIENTS_FOUND: 'No patients found',
        },
        FORMS: {
            LABEL_zero: '0 Forms',
            LABEL_one: '{{count}} Form',
            LABEL_other: '{{count}} Forms',
        },
        FORM_ERRORS: {
            UNABLE_TO_EDIT_SUBMITTED_FORM: 'Unable to perform save on submitted form',
            UNABLE_TO_EDIT_APPROVED_FORM: 'Approved forms can only be changed by amending. Use Save in the form actions to amend.',
            UNABLE_TO_SAVE_INVALID_FORM: 'Unable to save submitted form in invalid state',
            UNABLE_TO_SAVE_INVALID_EPISODE_PERIOD_PAST_60_DAYS: 'Unable to save form with an invalid episode period (past 60 days)',
        },
        FORM_TITLE: {
            'route-sheet': 'Route Sheet',
            abn: 'ABN',
            'patient-consent': 'Patient Consent',
            'physician-order': 'Physician Order',
            'lvn-supervisory': 'LVN Supervisory',
            'hha-supervisory': 'HHA Supervisory',
            'face-to-face': 'Face to Face',
            'discharge-summary': 'Discharge Summary',
            'sixty-day-summary': 'Sixty Day Summary',
            'patient-choice': 'Patient Choice',
            'pt-poc': 'PT Plan Of Care',
            'pt-discharge': 'PT Discharge',
            'pt-summary': 'PT Summary',
            'pt-visit': 'PT Visit',
            'hha-poc': 'HHA Plan Of Care',
            'ot-poc': 'OT Plan Of Care',
            'pta-visit': 'PTA Visit',
            'pta-supervisory': 'PTA Supervisory Visit',
            'ot-supervisory': 'OTA Supervisory Visit',
            'msw-follow-up': 'MSW Follow Up Visit Note',
            'msw-assessment': 'MSW Assessment',
            'ot-visit': 'OT Visit',
            'ot-discharge': 'OT Discharge',
            '485-poc': '485 Plan Of Care',
            'hha-visit': 'HHA Visit',
            'pt-eval': 'PT Evaluation',
            'pt-re-eval': 'PT Re Evaluation',
            'ot-eval': 'OT Evaluation',
            'ot-re-eval': 'OT Re Evaluation',
            'st-discharge': 'ST Discharge',
            'st-poc': 'ST Plan Of Care',
            'st-eval': 'ST Eval',
            nomnc: 'NOMNC',
            hhccn: 'HHCCN',
        },
        FILE_UPLOAD: {
            SUCCESS: 'Files successfully uploaded',
            FAILURE: 'Unable to upload some files',
            PARTIAL_FAILURE: '{{count}} file(s) failed to upload: {{names}}',
            ERRORS: {
                FILE_TOO_LARGE: 'File(s) too large, maximum {{maxSize}}mb',
                TOO_MANY_FILES: 'Too many files, limited to {{count}} files per upload',
                FILE_INVALID_TYPE: 'Invalid file type',
                FILE_TOO_SMALL: 'File too small',
                FILE_INVALID: 'Invalid file',
                UNKNOWN_ERROR: 'Unknown error',
            },
        },
        OASIS: {
            '*': {
                NAME: '',
            },
            soc: {
                NAME: 'Oasis SOC',
            },
            roc: {
                NAME: 'Oasis ROC',
            },
            rct: {
                NAME: 'Oasis recertification',
            },
            tr: {
                NAME: 'Oasis Transfer',
            },
            trd: {
                NAME: 'Oasis Transfer Discharge',
            },
            ofu: {
                NAME: 'Oasis other follow up',
            },
            dsch: {
                NAME: 'Oasis discharge',
            },
            dth: {
                NAME: 'Oasis Death At Home',
            },
            NEW_EPISODE: {
                roc: {
                    ALERT: {
                        TITLE: 'Would you like to start the next episode?',
                        MESSAGE: `Saving this form will create the next episode of care. Continue?`,
                    },
                },
                rct: {
                    ALERT: {
                        TITLE: 'Would you like to start the next episode?',
                        MESSAGE: `Saving this form will create the next episode of care. Continue?`,
                    },
                },
            },
            STATUS_CHANGE: {
                soc: {
                    ALERT: {
                        TITLE: 'Would you like to admit the patient?',
                        MESSAGE: `Saving this form will admit and create this patient's episode. Continue?`,
                    },
                },
                roc: {
                    ALERT: {
                        TITLE: `Would you like to resume the patient's episode?`,
                        MESSAGE: `Saving this form will resume the patient's episode of care. Continue?`,
                    },
                },
                tr: {
                    ALERT: {
                        TITLE: 'Would you like to transfer the patient?',
                        MESSAGE: `Saving this form will transfer the patient. Continue?`,
                    },
                },
                trd: {
                    ALERT: {
                        TITLE: 'Would you like to transfer and discharge the patient?',
                        MESSAGE: `Saving this form will transfer and discharge the patient. Continue?`,
                    },
                },
                dsch: {
                    ALERT: {
                        TITLE: 'Would you like to discharge the patient?',
                        MESSAGE: `Saving this form will discharge the patient. Continue?`,
                    },
                },
                dth: {
                    ALERT: {
                        TITLE: `Would you like to record the patient's death?`,
                        MESSAGE: `Saving this form will discharge and end the patient's episode. Continue?`,
                    },
                },
            },

            SectionA: {
                TITLE: 'Administrative',
                DESCRIPTION: 'Verify/update at SOC. Most fields auto-populate from intake.',
            },
            SectionB: { TITLE: 'Neurological' },
            SectionC: { TITLE: 'Neurological' },
            SectionBC: { TITLE: 'Neurological' },
            SectionD: { TITLE: 'Mood & Behavior' },
            SectionE: { TITLE: 'Mood & Behavior' },
            SectionDE: { TITLE: 'Mood & Behavior' },
            SectionF: { TITLE: 'Preferences' },
            SectionG: { TITLE: 'Functional Status' },
            SectionGG: { TITLE: 'Functional Goals' },
            SectionH: { TITLE: 'GI / GU' },
            SectionI: { TITLE: 'Active Diagnoses' },
            SectionJ: { TITLE: 'Health Conditions' },
            SectionK: { TITLE: 'Nutrition' },
            SectionM: { TITLE: 'Skin Conditions' },
            Medication: { TITLE: 'Medication' },
            SectionN: { TITLE: 'High Risk Medications' },
            SectionO: { TITLE: 'Special Procedures' },
            Vitals: { TITLE: 'Vitals' },
            SectionQ: { TITLE: 'Items Collected at TRF/DC' },
            Cardiovascular: { TITLE: 'Cardiovascular' },
            Endocrine: { TITLE: 'Endocrine' },
            HealthManagement: { TITLE: 'Health Management' },
            Respiratory: { TITLE: 'Respiratory' },
            Ostomy: { TITLE: 'Ostomy' },
            Labdraw: { TITLE: 'Lab Draw' },
            Narrative: { TITLE: 'Narrative' },
            CoordinationOfCare: { TITLE: 'Coordination of Care' },
            Supplies: { TITLE: 'Supplies' },
            PlanOfCare: { TITLE: 'Plan Of Care' },
            Homebound: { TITLE: 'Homebound Status' },
            Signature: { TITLE: 'Signature' },
        },
        POC: {
            General: { TITLE: 'General' },
            PlanOfCare: { TITLE: 'Orders' },
            Medications: { TITLE: 'Medications' },
            HomeboundReason: { TITLE: 'Homebound' },
            AbilityLimitation: { TITLE: 'Ability & Limitations' },
            Hospitalization: { TITLE: 'Hospitalization' },
            MentalStatus: { TITLE: 'Mental Status' },
            Supplies: { TITLE: 'Supplies' },
            Safety: { TITLE: 'Safety' },
            DisciplineOrders: { TITLE: 'Orders for Discipline' },
            GeneralOrders: { TITLE: 'General Orders' },
            NutritionAllergies: { TITLE: 'Nutrition & Allergies' },
            Signature: { TITLE: 'Signature' },
        },
        HHA_VISIT: {
            General: { TITLE: 'General' },
            Vitals: { TITLE: 'Vitals' },
            Bathing: { TITLE: 'Bathing' },
            PersonalCare: { TITLE: 'Personal Care' },
            Other: { TITLE: 'Other' },
            Reported: { TITLE: 'Reported' },
            Ambulation: { TITLE: 'Ambulation' },
            Signature: { TITLE: 'Signature' },
        },
        HHA_POC: {
            PatientInformation: { TITLE: 'Patient Information' },
            Vitals: { TITLE: 'Vitals' },
            Bathing: { TITLE: 'Bathing' },
            PersonalCare: { TITLE: 'Personal Care' },
            AmbulationLocomotion: { TITLE: 'Ambulation' },
            Other: { TITLE: 'Other' },
            Reported: { TITLE: 'Report' },
            Signature: { TITLE: 'Signature' },
        },
        PT_OT_EVAL: {
            General: { TITLE: 'General' },
            HistoryDiagnosis: { TITLE: 'History Diagnosis' },
            ClinicalImpairment: { TITLE: 'Clinical Impairments' },
            FunctionalStatus: { TITLE: 'Overall Functional Status' },
            PlanOfCare: { TITLE: 'Plan Of Care' },
            Signature: { TITLE: 'Signature' },
        },
        VISIT: {
            ERROR_TITLE: 'Unable to schedule visit',
            ERRORS: {
                NO_EPISODE: 'No episode found for patient',
                INCORRECT_TIME: 'Visit time must be at least 20 minutes in length',
                INVALID_FORM: 'Unsupported form type',
                UNKNOWN_VISIT_TYPE: 'Unknown visit type',
                UNKNOWN_ASSIGNEE: 'Unknown assignee',
                DUPLICATE_SOC: 'Start of care visit already scheduled',
                DISCHARGE_VISIT_EXISTS: 'Death, Discharge or Transfer visit already scheduled',
                INVALID_RECERTIFICATION_DATE: 'Recertification has to be scheduled within 5 days of the end of the episode',
                NO_SOC: 'You cannot schedule a visit without a Start of Care date',
                VISIT_BEFORE_SOC: 'You cannot schedule a visit before the Start of Care visit',
                NO_SOC_AFTER_DISCHARGE: 'Unable to schedule a start of care, patient is discharged from this admission',
            },
        },
        SNN: {
            ActiveDiagnoses: { TITLE: 'Active Diagnoses' },
            PlanOfCare: { TITLE: 'Plan of Care' },
            Infections: { TITLE: 'Infections' },
            Incidents: { TITLE: 'Incidents' },
            SkinConditions: { TITLE: 'Skin Conditions' },
            Medication: { TITLE: 'Medications' },
            Supplies: { TITLE: 'Supplies' },
            Vitals: { TITLE: 'Vitals' },
            Neurosensory: { TITLE: 'Neurological' },
            BladderBowel: { TITLE: 'GI / GU' },
            Ostomy: { TITLE: 'Ostomy' },
            Respiratory: { TITLE: 'Respiratory' },
            Cardiovascular: { TITLE: 'Cardiovascular' },
            Endocrine: { TITLE: 'Endocrine' },
            HealthManagement: { TITLE: 'Health Management' },
            ENTMouth: { TITLE: 'ENT Mouth' },
            Nutrition: { TITLE: 'Nutrition' },
            Musculoskeletal: { TITLE: 'Musculoskeletal' },
            HomeboundReason: { TITLE: 'Homebound' },
            Labdraw: { TITLE: 'Lab Draw' },
            SubjectiveReport: { TITLE: 'Subjective / Patient Report' },
            CoordinationOfCare: { TITLE: 'Coordination of Care' },
            Signature: { TITLE: 'Signature' },
        },
        CARRY_FORWARD: {
            SECTION_VALIDATION_ERROR: 'Please fix validation errors before confirming this section.',
            ENTER_DOCUMENTATION_CONFIRM:
                "Once you continue, you won't be able to come back to this review screen, and the visit will move from Draft to In Progress. Make sure you've reviewed everything first.",
        },
        BILLING: {
            STATUS: {
                NOT_READY: 'Not Ready',
                SENT: 'Sent',
                READY: 'Ready',
                CANCELLED: 'Cancelled',
            },
            NOT_READY_REASON: {
                MISSING_CLAIM_FIELDS: 'Required claim information is incomplete.',
                MISSING_PRIVATE_INSURANCE_CONFIG:
                    '{{payerName}} must be configured before claims can be submitted. Configure in Settings →',
                EXPIRED_INSURANCE_CONTRACT:
                    'The payer contract for {{payerName}} expired on {{contractEndDate}}. Renew the contract in Settings →',
                THIS_PAYER: 'This payer',
                NO_CLAIM_VISITS: "No billable visits fall within this claim's service period.",
                MISSING_VISIT_CODES: 'One or more visit types are missing a revenue or service code.',
                VISITS_NOT_APPROVED: 'One or more visits have not been approved (route sheet not approved).',
                INCOMPLETE_AGENCY_ZIP:
                    'Branch address must include a complete ZIP+4 (9 digits). Update the branch address in settings before submitting.',
                KX_MISSING_REMARKS: 'This claim requests a late-NOA exception. Add a remark explaining why before you can submit.',
            },
            CLAIM_WARNING: {
                EXPIRED_INSURANCE_CONTRACT_VISITS:
                    'The payer contract for {{payerName}} expired on {{contractEndDate}}. The following services will not be paid. Renew the contract in Settings →',
                UNPAID_SERVICE_LINE: '{{visitDate}} · {{visitType}}',
            },
            CLAIM_FIELD: {
                admissionStatus: 'Admission status',
                admissionType: 'Admission type',
                attendingPhysician: 'Attending physician',
                careLocation: 'Care location',
                occurrenceCodes: 'Occurrence codes',
                valueCodes: 'Value codes',
            },
        },
        NOTE_SUMMARY: {
            ERRORS: {
                REJECTED_QUOTA: 'Daily note generation quota reached. Please write the narrative manually.',
                PROVIDER_GUARDRAIL_BLOCKED: 'Generation was blocked for compliance reasons. Please write the narrative manually.',
                LLM_VALIDATION_FAILED: 'Note generation returned an unexpected response. Please try again or write the narrative manually.',
                LLM_PARSE_FAILED: 'Note generation returned an unexpected response. Please try again or write the narrative manually.',
                PROVIDER_THROTTLED: 'Note generation is temporarily unavailable. Please try again in a few moments.',
                PROVIDER_TRANSIENT: 'Note generation is temporarily unavailable. Please try again in a few moments.',
                TIMEOUT_TRANSIENT: 'Note generation is temporarily unavailable. Please try again in a few moments.',
                PROVIDER_VALIDATION: 'Generation failed because of a configuration error. Please contact support.',
                AUTH_FAILED: 'Generation failed because of a configuration error. Please contact support.',
                PRICING_MISSING: 'Generation failed because of a configuration error. Please contact support.',
                UNKNOWN_FEATURE: 'Generation failed because of a configuration error. Please contact support.',
                LEASE_EXPIRED: 'Generation failed. Please try again or write the narrative manually.',
                LEASE_LOST: 'Generation failed. Please try again or write the narrative manually.',
                LLM_CALL_IN_FLIGHT: 'Generation failed. Please try again or write the narrative manually.',
                MODEL_NOT_ALLOWED: 'Generation failed. Please try again or write the narrative manually.',
                INVALID_PAYLOAD_SCHEMA: 'Generation failed. Please try again or write the narrative manually.',
                UNSUPPORTED_FORM_TYPE: 'Generation failed. Please try again or write the narrative manually.',
                PHI_GUARD_VIOLATION: 'Generation failed. Please try again or write the narrative manually.',
                PAYLOAD_INTEGRITY_FAILED: 'Generation failed. Please try again or write the narrative manually.',
                CALL_IDENTITY_COLLISION: 'Generation failed. Please try again or write the narrative manually.',
                CALL_SIGNATURE_MISMATCH: 'Generation failed. Please try again or write the narrative manually.',
                JSON_SCHEMA_NOT_FOUND: 'Generation failed. Please try again or write the narrative manually.',
                LLM_OUTPUT_TRUNCATED: 'Generation failed. Please try again or write the narrative manually.',
                MAX_CALLS_EXCEEDED: 'Generation failed. Please try again or write the narrative manually.',
                CREATE_STUCK: 'Generation failed. Please try again or write the narrative manually.',
                JOB_STUCK: 'Generation failed. Please try again or write the narrative manually.',
                TIMEOUT: 'Generation failed. Please try again or write the narrative manually.',
                UNKNOWN_IN_FLIGHT: 'Generation failed. Please try again or write the narrative manually.',
                LEASE_EXPIRED_PRE_INVOKE: 'Generation failed. Please try again or write the narrative manually.',
                LEASE_EXPIRED_PRE_RESERVE: 'Generation failed. Please try again or write the narrative manually.',
                QUOTA_ATTRIBUTE_INVALID_VALUE: 'Generation failed. Please try again or write the narrative manually.',
                UNKNOWN_ERROR: 'Generation failed. Please try again or write the narrative manually.',
                QUOTA_ATTRIBUTE_UNREGISTERED: 'Generation failed. Please try again or write the narrative manually.',
            },
        },
    },
};
